"use strict";

export default function routes($stateProvider) {
  "ngInject";

  $stateProvider
    .state("logout", {
      url: "/logout?referrer",
      referrer: "main",
      template: "",
      controller($state, Auth) {
        "ngInject";

        var referrer =
          $state.params.referrer || $state.current.referrer || "main";
        Auth.logout().then(() => {
          $state.go(referrer);
          return;
        });
      },
    })
    .state("contact", {
      url: "/contact",
      template: require("./contact/contact.html"),
      controller: "ContactController",
      controllerAs: "ct",
      authenticate: false,
    })
    .state("legal", {
      url: "/legal",
      template: require("./legal/legal.html"),
      controller: "LegalController",
      controllerAs: "legal",
      authenticate: false,
    })
    .state("settings", {
      url: "/settings",
      template: require("./settings/settings.html"),
      controller: "SettingsController",
      controllerAs: "vm",
      authenticate: true,
    })
    .state("forgotten", {
      url: "/forgotten",
      template: require("./forgotten/forgotten.html"),
      controller: "ForgottenController",
      controllerAs: "vm",
      authenticate: false,
    })
    .state("signup", {
      url: "/signup",
      template: require("./signup/signup.html"),
      controller: "SignupController",
      controllerAs: "vm",
      authenticate: false,
    });
}



// WEBPACK FOOTER //
// ./client/app/account/account.routes.js